import Axios from '@/axios'

// 查询授权资源包模板：web:resourcePackageTemplate:index
export const QueryTemplateList = data => {
  return Axios({
    url: '/device-manager/web-api/resource-package-template/index',
    method: 'POST',
    type: 'json',
    data
  })
}

// 创建授权资源包模板：web:resourcePackageTemplate:create
export const TemplateCreate = data => {
  return Axios({
    url: '/device-manager/web-api/resource-package-template/create',
    method: 'POST',
    type: 'json',
    data
  })
}

// 修改授权资源包模板：web:resourcePackageTemplate:update
export const TemplateUpdate = data => {
  return Axios({
    url: `/device-manager/web-api/resource-package-template/update/${data.id}`,
    method: 'POST',
    type: 'json',
    data
  })
}

// 删除授权资源包模板：web:resourcePackageTemplate:delete
export const TemplateDelete = id => {
  return Axios({
    url: `/device-manager/web-api/resource-package-template/delete/${id}`,
    method: 'POST',
    type: 'json'
  })
}
